


















































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CategoryApi from '@/api/goods/category'
import BrandApi from '@/api/goods/brand'
import SpecsApi from '@/api/goods/specs'
import GoodsApi from '@/api/goods/list'
import ParameterCategoryApi from '@/api/goods/parameter/category'
import UploadOSS from '@/components/upload/index.vue'
import PicModal from '@/components/upload/picModal.vue'
import draggable from 'vuedraggable'
import EditorCustomize from '@/components/editorCustomize/index.vue'
import CategorySelect from '@/components/category-select/index.vue'
class CreateOrUpdateCommodityDto {
  constructor() {
    this.marketPrice = 0
    this.price = 0
    this.published = true
    this.isTop = false
    this.description = ''
    this.productSKUs = []
    this.productTagMappings = []
    this.productImages = []
    this.videoUrl = null
    this.stockQuantity = 0
  }
  brandId: number
  name: string
  code: string
  marketPrice: number
  price?: number
  stockQuantity: number
  published: boolean
  isTop: boolean
  // 商品详情
  description: string
  year: string
  season: string
  videoUrl: string
  productSKUs: CommoditySKUDto[]
  productTagMappings: any[]
  productCategoryMappings: string
  productImages: ProductImageDto[]
  marketingType?: number
  beginTime?: Date
  endTime?: Date
}
class CommoditySKUDto {
  id?: number
  commodityId?: number
  stockQuantity: string | number
  pictureUrl: string
  attributeXml: string
  attributeVal: string
  price: number
  code: string
  marketPrice?: number
}
class SalesAttributesDto {
  id?: number
  commodityId?: number
  specificationsId: number
  specificationsValueId: number
}
class ProductImageDto {
  pictureUrl: string
  isDelete: boolean
  id?: number
  displayOrder: number
}
@Component({
  components: {
    UploadOSS,
    PicModal,
    draggable,
    EditorCustomize,
    CategorySelect,
  },
})
export default class GoodsEdit extends AbpBase {
  editId: any = null

  loading: boolean = false
  categoryOptions: any[] = []
  brandOptions: any[] = []

  formValidate: CreateOrUpdateCommodityDto = new CreateOrUpdateCommodityDto()
  ruleValidate: any = {
    brandId: [
      {
        required: true,
        type: 'number',
        message: '请选择品牌',
        trigger: 'change',
      },
    ],
    productCategoryMappings: [
      {
        required: true,
        type: 'string',
        message: '请选择商品分类',
        trigger: 'change',
      },
    ],
    name: [
      {
        required: true,
        message: '请输入商品名称',
        trigger: 'blur',
      },
    ],
    code: [
      {
        required: true,
        message: '请输入商品款号',
        trigger: 'blur',
      },
    ],
    price: [
      {
        required: true,
        message: '请输入售价',
        type: 'number',
        trigger: 'blur',
      },
      {
        type: 'number',
        min: 0.01,
        message: '最低价格要大于0.01',
        trigger: 'blur',
      },
    ],
    marketPrice: [
      {
        required: true,
        message: '请输入吊牌价',
        type: 'number',
        trigger: 'blur',
      },
      {
        type: 'number',
        min: 0.01,
        message: '最低价格要大于0.01',
        trigger: 'blur',
      },
    ],
    // stockQuantity: [
    //   {
    //     required: true,
    //     message: '请输入商品库存',
    //     type: 'number',
    //     trigger: 'blur'
    //   }
    // ]
  }
  // 商品规格属性
  specsOptions: any[] = []
  // 商品颜色规格属性
  goodsColors: any[] = []
  // 选择了的商品规格
  selectSpecsList: any[] = []
  // 勾选的商品规格属性值组
  specsCheck: any[] = []
  skuTableHeader: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: 'SKU',
      align: 'center',
      key: 'attributeXml',
    },
    {
      title: '吊牌价',
      align: 'center',
      slot: 'marketPrice',
      key: 'marketPrice',
    },
    {
      title: '销售价格',
      align: 'center',
      slot: 'price',
      key: 'price',
    },
    {
      title: '商品库存',
      align: 'center',
      slot: 'stockQuantity',
      key: 'stockQuantity',
    },
    {
      title: '编码',
      align: 'center',
      slot: 'code',
      key: 'code',
    },
    {
      title: '图片',
      align: 'center',
      slot: 'photo',
      key: 'pictureUrl',
    },
    {
      title: '上传',
      align: 'center',
      slot: 'photoUrl',
    },
    // {
    //   title: '操作',
    //   align: 'center',
    //   slot: 'action',
    // },
  ]
  // 商品sku缓存值
  tableData: any = {}
  // 商品参数选择值缓存
  attrDictData: any = {}
  batchMarketPrice: number | string = ''
  batchPrice: number | string = ''
  batchStock: number | string = ''
  batchCode: number | string = ''

  // 商品参数
  attrCategoryList: any[] = []
  categorysCheck: any[] = []
  attrTableData: any[] = []
  copyAttrTableData: any[] = []

  // 商品头图
  productColorImages: any[] = []
  // 可选择上传的图片
  selectPicNumberCan: number = 0
  // 判断是新增商品还是编辑商品
  isAddGoods: boolean = true

  attrTableHeader: any[] = [
    {
      title: '参数类型',
      align: 'center',
      key: 'name',
    },
    {
      title: '参数名称',
      align: 'center',
      slot: 'productAttributes',
    },
    {
      title: '参数值',
      align: 'center',
      slot: 'productAttributeValues',
    },
  ]
  tagList = []
  checkAllTag = []

  // 计算折扣率
  get discount() {
    if (this.formValidate.marketPrice > 0) {
      return (this.formValidate.price / this.formValidate.marketPrice).toFixed(2)
    } else {
      return ''
    }
  }
  // 计算库存是否禁用
  get stockQuantityDisabled() {
    let list = this.formValidate.productSKUs || []
    return list.length > 0
  }

  get selectPicNumber() {
    let num = 6
    let list = this.formValidate.productImages.filter((item) => !item.isDelete)
    let len = num - list.length
    return len > 0 ? len : 0
  }

  async mounted() {
    let vm = this
    if (vm.$route.params['id']) {
      vm.editId = vm.$route.params['id']
      this.isAddGoods = false
    } else {
      this.isAddGoods = true
    }
    await vm.getGoodsBrand()
    await vm.getCategoriesAll()
    await vm.getGoodsSpecs()
    await vm.getGoodTag()
    await vm.getGoodsAttrCategory()
    if (vm.editId) {
      vm.getData()
    }
  }

  getData() {
    GoodsApi.getDataById(this.editId).then((res) => {
      if (res.data) {
        let { productSKUs, productAttributeMappings, productSalesAttributeMappings } = res.data
        if (res.data.productCategoryMappings.length > 0) {
          res.data.productCategoryMappings = res.data.productCategoryMappings.map((item) => item.categoryId)[0]
        }
        this.selectSpecsList = this.getSelectSpecsList(productSalesAttributeMappings, productSKUs)
        if (productSKUs.length) {
          let selectSpecsListCopy = JSON.parse(JSON.stringify(this.selectSpecsList))
          selectSpecsListCopy.forEach((item) => {
            if (item.productSalesAttributeValues) {
              item.productSalesAttributeValues.forEach((child) => {
                child.name = item.name + ':' + child.name
              })
            }
          })
          const specsCheck = this.getSpecsCheckBySkus(productSKUs)
          const specsAttrArr = specsCheck.map((item, index) => {
            return item.map((id) =>
              selectSpecsListCopy[index].productSalesAttributeValues.find((attrItem) => attrItem.id === id)
            )
          })

          // 根据颜色分头图
          this.productColorImages = this.dealNewHeadFigure(res.data.productColorImages)
          // console.log(this.productColorImages, specsAttrArr, specsCheck);
          if (this.productColorImages.length && specsAttrArr && !specsAttrArr[0].includes(undefined)) {
            this.goodsColors = specsAttrArr.filter((item) => {
              return item.length && item[0].name.includes('颜色')
            })[0]
            // console.log(this.productColorImages, this.goodsColors)
            let goodsColorsColor = this.goodsColors.map((item) => {
              return item.name.split(':')[1] ? item.name.split(':')[1] : item.name
            })
            let productColorImagesColor = this.productColorImages.map((item) => {
              return item.color
            })

            let len = goodsColorsColor.length
            let len2 = productColorImagesColor.length
            for (let i = 0; i < len; i++) {
              if (!productColorImagesColor.includes(goodsColorsColor[i])) {
                let obj = {
                  color: goodsColorsColor[i],
                  data: [],
                }
                productColorImagesColor.push(goodsColorsColor[i])
                this.productColorImages.push(obj)
              }
            }
            // console.log(this.productColorImages, this.goodsColors);
          } else if (specsAttrArr && !specsAttrArr[0].includes(undefined)) {
            this.goodsColors = specsAttrArr.filter((item) => {
              return item.length && item[0].name.includes('颜色')
            })[0]
          }
        }

        res.data.productTagMappings = res.data.productTagMappings.map((item) => item.productTagId)

        // this.specsCheck = this.getSpecsCheckBySkus(productSKUs);
        this.getSpecsCheckBySkus(productSKUs).forEach((item, index) => {
          this.$set(this.specsCheck, index, item)
        })
        // this.checkGroupChange(this.specsCheck, true)
        this.tableData = this.getSkuDict(productSKUs)
        this.categorysCheck = this.getCategorysCheck(productAttributeMappings)
        this.setAttrTableData(productAttributeMappings)
        console.log('商品详情----》', res.data)
        this.formValidate = res.data
        this.formValidate.beginTime = res.data.beginTime ? new Date(res.data.beginTime) : null
        this.formValidate.endTime = res.data.endTime ? new Date(res.data.endTime) : null
      }
    })
  }
  //   getSpecsCheckBySkus2(skuArr) {
  //   const checkArr = []
  //   if (skuArr && skuArr.length) {
  //     skuArr.forEach((item) => {
  //       const idArr = item.attributeVal.split('/')
  //       const sizeArr = item.attributeXml.split('/')
  //       idArr.forEach((itemId, index) => {
  //         if (!checkArr[index]) {
  //           checkArr[index] = {}
  //           checkArr[index].id = 0
  //           checkArr[index].name = ''
  //           checkArr[index].test = []
  //           checkArr[index].productSalesAttributeValues = []
  //         }
  //         if (!checkArr[index].test.includes(itemId)) {
  //           checkArr[index].id = item.id
  //           checkArr[index].name = sizeArr[index].split(':')[0]
  //           const obj: any = {}
  //           obj.id = Number(itemId)
  //           obj.name = sizeArr[index].split(':')[1]
  //           obj.pictureUrl = item.pictureUrl
  //           checkArr[index].test.push(itemId)
  //           checkArr[index].productSalesAttributeValues.push(obj)
  //         }
  //       })
  //     })
  //   }
  //   console.log('带有图片的sku', checkArr);
  //   // console.log(obj);
  //   return checkArr
  // }
  /**
   * 新商品头图重新优化 对象
   */
  // dealNewHeadFigure(arr: any[]) {
  //   let checkArr = []
  //   let imgObj = {}
  //   if (arr && arr.length) {
  //     for (let i = 0; i < arr.length; i++) {
  //       let a = arr[i]
  //       if (checkArr.indexOf(a.color) == -1) {
  //         checkArr.push(a.color)
  //       }
  //     }
  //     checkArr.forEach((item, index) => {
  //       arr.forEach((item1, index1) => {
  //         if (item === arr[index1].color) {
  //           if (imgObj[item]) {
  //             imgObj[item].push(arr[index1])
  //           } else {
  //             imgObj[item] = [arr[index1]]
  //           }
  //         }
  //       })
  //     })
  //   }
  //   console.log(checkArr, imgObj)
  //   return imgObj
  // }
  dealNewHeadFigure(arr: any[]) {
    let map = {},
      dest = []
    for (let i = 0; i < arr.length; i++) {
      let ai = arr[i]
      if (!map[ai.color]) {
        dest.push({
          color: ai.color,
          data: [ai],
        })
        map[ai.color] = ai
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j]
          if (dj.color == ai.color) {
            dj.data.push(ai)
            break
          }
        }
      }
    }
    return dest
  }
  getSelectSpecsList(productSalesAttributeMappings, productSkus) {
    // 新版
    let arr: any = []
    let productskuId, twoproductskuId;
    // 这里解决productSalesAttributeMappings和productskus错位的问题
    if (productSkus.length) {
      productskuId = productSkus[0].attributeVal.split('/')[0]
      let index = productSalesAttributeMappings.findIndex(item => item.productSalesAttributeValueId == productskuId)
      let obj = productSalesAttributeMappings.find(item => item.productSalesAttributeValueId == productskuId)
      if (JSON.stringify(obj) != '{}' && index > -1 && index != 0) {
        productSalesAttributeMappings.splice(index, 1)
        productSalesAttributeMappings.unshift(obj)
      }
      twoproductskuId = productSkus[0].attributeVal.split('/')[1]
      if (twoproductskuId) {
        let index = productSalesAttributeMappings.findIndex(
          (item) => item.productSalesAttributeValueId == twoproductskuId
        )
        let obj = productSalesAttributeMappings.find((item) => item.productSalesAttributeValueId == twoproductskuId)
        if (JSON.stringify(obj) != '{}' && index > -1 && index != 0) {
          productSalesAttributeMappings.splice(index, 1)
          productSalesAttributeMappings.splice(1, 0, obj)
        }
      }
    }
    productSalesAttributeMappings.forEach((item) => {
      if (!arr.includes(item.productSalesAttributeId)) {
        arr.push(item.productSalesAttributeId)
      }
    })

    let tempArr: any[] = []
    arr.forEach((item) => {
      if (item) {
        if (this.specsOptions.length > 0) {
          tempArr.push(
            this.specsOptions.find((opItem) => {
              return opItem.id && opItem.id === item
            })
          )
        }
      }
    });
    console.log('处理数据222', tempArr, productSkus, this.specsOptions);
    return tempArr

    // 旧版
    // let obj: any = {}
    // productSalesAttributeMappings.forEach((item) => {
    //   obj[item.productSalesAttributeId] = item.productSalesAttributeId
    // })
    // let specsIdArr = Object.values(obj)

    // let tempArr: any[] = []
    // specsIdArr.forEach((item) => {
    //   if (item) {
    //     if (this.specsOptions.length > 0) {
    //       tempArr.push(
    //         this.specsOptions.find((opItem) => {
    //           return opItem.id && opItem.id === item
    //         })
    //       )
    //     }
    //   }
    // })
    // return tempArr
  }

  /**
   * 选择sku图片
   */
  skuImgChange(event, index) {
    let tempTableData = JSON.parse(JSON.stringify(this.tableData))
    this.formValidate.productSKUs[index].pictureUrl = event[0].url
    const item = this.formValidate.productSKUs[index]
    tempTableData[item.attributeVal]['pictureUrl'] = event[0].url
    this.tableData = tempTableData
  }

  /**
   * 批量选择图片
   */
  skuImgChangeAll(event) {
    let skuTable = (this.$refs.skuTable as any).getSelection()
    if (skuTable.length) {
      let tempTableData = JSON.parse(JSON.stringify(this.tableData))
      this.formValidate.productSKUs.forEach((item) => {
        skuTable.forEach((child) => {
          if (item.attributeVal == child.attributeVal) {
            item.pictureUrl = event[0].url
            tempTableData[item.attributeVal]['pictureUrl'] = event[0].url
          }
        })
      })
      this.tableData = tempTableData
    } else {
      this.$Notice.warning({
        title: '请先选择商品规格',
      })
    }
  }

  /**
   * 选择视频
   */
  videoChange(event) {
    this.formValidate.videoUrl = event[0].url
  }

  deleteVideo() {
    this.formValidate.videoUrl = null
  }

  /**
   * 商品详情
   */
  editorChange(e) {
    this.formValidate.description = e
  }

  /**
   * 点击头图把点中的那行需要上传的数量
   */
  handleClickSelecImg(indexColor) {
    if (this.productColorImages.length) {
      let list = this.productColorImages[indexColor].data.filter((item) => !item.isDelete)
      this.selectPicNumberCan = 6 - list.length
    } else {
      this.selectPicNumberCan = 6
      if (this.goodsColors.length) {
        this.productColorImages = this.goodsColors.map((item) => {
          return {
            data: [],
            color: item.name.split(':')[1],
          }
        })
      }
    }
  }

  /**
   * 商品头图选择
   */
  headPicFn(itemColor, indexColor, event) {
    console.log(itemColor, indexColor)
    let len
    if (this.productColorImages.length) {
      let list = this.productColorImages[indexColor].data.filter((item) => !item.isDelete)
      len = 6 - list.length
    } else {
      len = 6
    }
    len = len > event.length ? event.length : len
    this.isAddGoods = false
    for (let i = 0; i < len; i++) {
      // let obj = new ProductImageDto()
      let obj = {
        color: itemColor.color
          ? itemColor.color.split(':')[1]
            ? itemColor.color.split(':')[1]
            : itemColor.color
          : itemColor.name.split(':')[1]
          ? itemColor.name.split(':')[1]
          : itemColor.name,
        pictureUrl: event[i].url,
        id: event[i].id,
        isDelete: false,
        // name: this.formValidate.name,
        // productId: this.editId
      }
      this.productColorImages[indexColor].data.push(obj)
    }
  }
  /**
   * 商品头图选择
   */
  headPicFn2(event) {
    let list = this.formValidate.productImages.filter((item) => !item.isDelete)
    let len = 6 - list.length
    len = len > event.length ? event.length : len
    for (let i = 0; i < len; i++) {
      let obj = new ProductImageDto()
      obj.pictureUrl = event[i].url
      this.formValidate.productImages.push(obj)
    }
  }
  /**
   * 删除商品头图 多颜色的
   */
  removeImg(index, indexColor) {
    let item = this.productColorImages[indexColor].data[index]
    if (item.id) {
      item.isDelete = true
    } else {
      this.productColorImages[indexColor].data.splice(index, 1)
    }
  }

  async getGoodsSpecs() {
    if (!this.editId) {
      await SpecsApi.getAll().then((res) => {
        this.specsOptions = res.data.items
      })
    } else {
      await GoodsApi.getProductSalesAttribute(this.editId).then((res) => {
        this.specsOptions = res.data
      })
    }
  }
  /**
   * 删除商品头图 默认的
   */
  removeImg2(index) {
    let item = this.formValidate.productImages[index]
    if (item.id) {
      item.isDelete = true
    } else {
      this.formValidate.productImages.splice(index, 1)
    }
  }
  /**
   * 获取商品标签
   */
  async getGoodTag() {
    await GoodsApi.getGoodTag(900, 0).then((res) => {
      if (res.data.items) {
        this.tagList = res.data.items
      }
    })
  }

  /**
   * 获取商品分类
   */
  async getCategoriesAll() {
    await GoodsApi.getCategoriesAll(null).then((res) => {
      if (res.data.items) {
        this.categoryOptions = res.data.items
      }
    })
  }

  async getGoodsBrand() {
    await BrandApi.getAll().then((res) => {
      this.brandOptions = res.data.items
    })
  }

  /**
   * 获取商品参数
   */
  async getGoodsAttrCategory() {
    function compare(property) {
      return function(a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    }
    await ParameterCategoryApi.getAll().then((res) => {
      // 按displayOrder字段重新排序，不然跟小程序那边顺序不一致
      res.data.items.forEach((item) => {
        item.productAttributes = item.productAttributes.sort(compare('displayOrder'))
      })
      this.attrCategoryList = res.data.items
      // console.log(JSON.stringify(res.data.items))
    })
  }

  /**
   * 判读售价是否大于吊牌价
   */
  priceChange() {
    setTimeout(() => {
      if (isNaN(this.formValidate.price)) {
        this.formValidate.price = 0
      }
      if (this.formValidate.price < 0) {
        this.formValidate.price = 0
      }
      if (isNaN(this.formValidate.marketPrice)) {
        this.formValidate.marketPrice = 0
      }
      if (this.formValidate.marketPrice < 0) {
        this.formValidate.marketPrice = 0
      }

      if (this.formValidate.marketPrice < this.formValidate.price) {
        this.formValidate.price = this.formValidate.marketPrice
        this.$Notice.warning({ title: '售价不能大于吊牌价' })
      }
    }, 100)
  }

  /**
   * 判读售价是否大于吊牌价
   */
  priceSkuChange() {
    setTimeout(() => {
      let tempTableData: any = {}
      tempTableData = JSON.parse(JSON.stringify(this.tableData))
      // this.formValidate.productSKUs.forEach((item, index) => {
      //   if (isNaN(item['marketPrice'])) {
      //     item['marketPrice'] = 0
      //     tempTableData[item.attributeVal]['marketPrice'] = 0
      //   }
      //   if (item['marketPrice'] < 0) {
      //     item['marketPrice'] = 0
      //     tempTableData[item.attributeVal]['marketPrice'] = 0
      //   }
      //   if (isNaN(item['price'])) {
      //     item['price'] = 0
      //     tempTableData[item.attributeVal]['price'] = 0
      //   }
      //   if (item['price'] < 0) {
      //     item['price'] = 0
      //     tempTableData[item.attributeVal]['price'] = 0
      //   }

      //   if (item['marketPrice'] < item['price']) {
      //     item['price'] = item['marketPrice']
      //     tempTableData[item.attributeVal]['price'] = item['marketPrice']
      //     this.$Notice.warning({ title: '销售价格不能大于吊牌价' })
      //   }
      //   return item
      // })
      let hasError = false
      for (let index = 0; index < this.formValidate.productSKUs.length; index++) {
        const item = this.formValidate.productSKUs[index]
        if (isNaN(item['marketPrice'])) {
          item['marketPrice'] = 0
          tempTableData[item.attributeVal]['marketPrice'] = 0
        }
        if (item['marketPrice'] < 0) {
          item['marketPrice'] = 0
          tempTableData[item.attributeVal]['marketPrice'] = 0
        }
        if (isNaN(item['price'])) {
          item['price'] = 0
          tempTableData[item.attributeVal]['price'] = 0
        }
        if (item['price'] < 0) {
          item['price'] = 0
          tempTableData[item.attributeVal]['price'] = 0
        }

        if (item['marketPrice'] < item['price']) {
          item['price'] = item['marketPrice']
          tempTableData[item.attributeVal]['price'] = item['marketPrice']
          this.$Notice.warning({ title: '销售价格不能大于吊牌价' })
          hasError = true
          break
        }
        tempTableData[item.attributeVal]['price'] = item['price']
        tempTableData[item.attributeVal]['marketPrice'] = item['marketPrice']
      }
      if (hasError) return
      this.tableData = tempTableData
    }, 100)
  }

  /**
   * 判断编码是否相同
   */
  codeSkuChange(index) {
    setTimeout(() => {
      let tempTableData: any = {}
      tempTableData = JSON.parse(JSON.stringify(this.tableData))
      let row = this.formValidate.productSKUs[index]
      // this.formValidate.productSKUs.forEach((item, itemIndex) => {
      //   if (item['code'] && item['code'] == row['code'] && index != itemIndex) {
      //     row['code'] = null
      //     tempTableData[row.attributeVal]['code'] = null
      //     this.$Notice.warning({ title: '编码不能相同' })
      //   }
      //   return item
      // })
      let hasError = false
      for (let itemIndex = 0; itemIndex < this.formValidate.productSKUs.length; itemIndex++) {
        const item = this.formValidate.productSKUs[itemIndex]
        if (item['code'] && item['code'] == row['code'] && index != itemIndex) {
          row['code'] = null
          tempTableData[row.attributeVal]['code'] = null
          this.$Notice.warning({ title: '编码不能相同' })
          hasError = true
          break
        } else if (index == itemIndex) {
          tempTableData[row.attributeVal]['code'] = row['code']
        }
      }
      if (hasError) return
      this.tableData = tempTableData
    }, 100)
  }

  /**
   * 库存改变
   */
  stockSkuChange() {
    let stock = 0
    this.formValidate.productSKUs.forEach((item, index) => {
      stock += Number(item.stockQuantity)
    })
    this.$set(this.formValidate, 'stockQuantity', stock)
  }

  // 选择规格类型后的调用的函数
  specsChange(selection) {
    let that = this
    this.selectSpecsList = []
    this.specsCheck = []
    let tempArr = []
    let tempCheckArr = []
    selection.forEach((item) => {
      const findItem = this.specsOptions.find((x) => x.id === item)
      if (findItem) {
        tempArr.push(findItem)
        tempCheckArr.push([])
      }
    })
    this.selectSpecsList = tempArr
    this.specsCheck = tempCheckArr
    // this.formValidate.productSKUs = []
    this.$set(this.formValidate, 'productSKUs', [])
  }

  /**
   * 添加商品规格
   */
  checkGroupChange(specsCheck: any[], notSet) {
    // 查看有没有没有选属性的数组
    // console.log(this.selectSpecsList);
    let vm = this
    specsCheck = notSet ? specsCheck : this.specsCheck
    const result = specsCheck.filter((item) => item.length === 0)
    if (result.length !== 0) {
      if (notSet) {
        return []
      } else {
        this.$set(this.formValidate, 'productSKUs', [])
        return false
      }
    }
    let selectSpecsList = JSON.parse(JSON.stringify(vm.selectSpecsList))
    selectSpecsList.forEach((item) => {
      if (item.productSalesAttributeValues) {
        item.productSalesAttributeValues.forEach((child) => {
          child.name = item.name + ':' + child.name
        })
      }
    })
    const specsAttrArr = specsCheck.map((item, index) => {
      return item.map((id) => selectSpecsList[index].productSalesAttributeValues.find((attrItem) => attrItem.id === id))
    })
    if (this.productColorImages.length) {
      this.goodsColors = specsAttrArr.filter((item) => {
        return item.length && item[0].name.includes('颜色')
      })[0]
      let goodsColorsColor = this.goodsColors.map((item) => {
        return item.name.split(':')[1] ? item.name.split(':')[1] : item.name
      })
      let productColorImagesColor = this.productColorImages.map((item) => {
        return item.color
      })
      let len = goodsColorsColor.length
      let len2 = productColorImagesColor.length
      for (let i = 0; i < len; i++) {
        if (!productColorImagesColor.includes(goodsColorsColor[i])) {
          let obj = {
            color: goodsColorsColor[i],
            data: [],
          }
          productColorImagesColor.push(goodsColorsColor[i])
          this.productColorImages.push(obj)
        }
      }
      // console.log(this.productColorImages, this.goodsColors);
    } else {
      this.goodsColors = specsAttrArr.filter((item) => {
        return item.length && item[0].name.includes('颜色')
      })[0]
      console.log('选中的sku颜色和尺码', specsAttrArr, this.goodsColors)
    }
    const skuArr = this._descartes(specsAttrArr)
    let skuNotEditArr = skuArr.map((item) => {
      var model = new CommoditySKUDto()
      let skuNameArr: any[] = []
      let skuIdArr: any[] = []
      item.forEach((item) => {
        skuNameArr.push(item.name)
        skuIdArr.push(item.id)
      })
      model.attributeXml = skuNameArr.join('/')
      model.attributeVal = skuIdArr.join('/')
      model.pictureUrl = ''
      model.price = this.formValidate.price || 0
      model.marketPrice = this.formValidate.marketPrice || 0
      model.stockQuantity = 0
      return model
    })
    if (notSet) {
      return skuNotEditArr
    } else {
      this.$set(this.formValidate, 'productSKUs', skuNotEditArr)
      // 这里又把引用对象给改了，所以缓存下来的值又同步回来了
      this.tableData = this.getSkuDict(skuNotEditArr)
    }
  }

  getSkuDict(skuArr: any[]) {
    let tempTableData: any = {}
    // 拷贝一份
    tempTableData = JSON.parse(JSON.stringify(this.tableData))
    skuArr.forEach((item, index) => {
      if (!tempTableData[item.attributeVal] || tempTableData[item.attributeVal]['attributeXml'] != item.attributeXml) {
        tempTableData[item.attributeVal] = item
      } else if (tempTableData[item.attributeVal]['attributeXml'] == item.attributeXml) {
        skuArr[index] = tempTableData[item.attributeVal]
      }
    })
    return tempTableData
  }

  _descartes(_arr) {
    const arr = _arr
    const end = arr.length - 1
    const result = []

    const recursive = (curr, start) => {
      const first = arr[start]
      const last = start === end
      for (let i in first) {
        var copy = curr.slice()
        copy.push(first[i])
        if (last) {
          result.push(copy)
        } else {
          recursive(copy, start + 1)
        }
      }
    }

    if (arr.length) recursive([], 0)

    return result
  }

  handleDeleteSkuRow(row, index) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        let copy = this.formValidate.productSKUs.slice()
        copy.splice(index, 1)
        // this.formValidate.productSKUs = copy
        this.$set(this.formValidate, 'productSKUs', copy)
        this.specsCheck = this.getSpecsCheckBySkus(copy)
      },
    })
  }

  getSpecsCheckBySkus(skuArr) {
    let checkArr = []
    skuArr.forEach((item) => {
      let idArr = item.attributeVal.split('/')
      idArr.forEach((item2, index) => {
        if (!checkArr[index]) {
          checkArr[index] = []
        }
        if (!checkArr[index].includes(Number(item2))) {
          checkArr[index].push(Number(item2))
        }
      })
    })
    console.log('12312312', checkArr)
    return checkArr
  }
  // handleReset() {
  //   let emptyArray = [] as any[]
  //   this.specsChange(this.selectSpecsList)
  //   this.categorysCheck = this.getCategorysCheck([])
  //   this.attrTableData =  emptyArray
  //   this.formValidate.videoUrl = ''
  //   this.formValidate.productImages = emptyArray
  //   this.formValidate.description = ''
  //   ;(this.$refs['formValidate'] as any).resetFields()
  // }
  handleSubmit() {
    (this.$refs['formValidate'] as any).validate((valid) => {
      // 有检查规则的已经通过
      if (valid) {
        let productAttributeMappings: any = []
        // 检查商品规格
        if (!this.formValidate.productSKUs.length) {
          this.$Modal.error({
            title: '请添加商品规格',
          })
          document.querySelector('.single-page-con').scrollTop = (this.$refs.specs as any).$el.offsetTop
          return
        }
        console.log('保存数据', this.formValidate.productSKUs);

        let isValid = this.formValidate.productSKUs.some((item) => {
          if (!item.marketPrice) {
            this.$Modal.error({
              title: '请输入SKU吊牌价',
            })
            return true
          }
          if (!item.marketPrice) {
            this.$Modal.error({
              title: '请输入SKU销售价格',
            })
            return true
          }
          // if (!item.stockQuantity) {
          //   this.$Modal.error({
          //     title: '请输入SKU库存'
          //   })
          //   return true
          // }
          if (!item.code) {
            this.$Modal.error({
              title: '请输入SKU编码',
            })
            return true
          }
          // if (!item.pictureUrl) {
          //   this.$Modal.error({
          //     title: '请选择SKU图片'
          //   })
          //   return true
          // }
        })
        if (isValid) {
          return
        }
        // 检查商品参数
        if (this.attrTableData.length > 0) {
          let isBreak = false
          let { attrTableData } = this

          for (let attrIndex = 0; attrIndex < attrTableData.length; attrIndex++) {
            const item = attrTableData[attrIndex]
            for (let i = 0, len = item.productAttributes.length; i < len; i++) {
              if (item.productAttributes[i].selectValue || item.productAttributes[i].customText) {
                if (item.productAttributes[i].selectValue && item.productAttributes[i].type === 0) {
                  productAttributeMappings.push({
                    productAttributeId: item.productAttributes[i].id,
                    productAttributeValueId: item.productAttributes[i].selectValue,
                    customText: '',
                  })
                } else if (item.productAttributes[i].customText && item.productAttributes[i].type === 2) {
                  productAttributeMappings.push({
                    productAttributeId: item.productAttributes[i].id,
                    productAttributeValueId: item.productAttributes[i].selectValue,
                    customText: item.productAttributes[i].customText,
                  })
                }
              } else {
                this.$Modal.error({
                  title: '请完善商品参数参数值',
                })
                isBreak = true
                document.querySelector('.single-page-con').scrollTop = (this.$refs.category as any).offsetTop
              }
              if (isBreak) break
            }
            if (isBreak) break
          }
          if (isBreak) return
        }
        // 最终检查完了，没问题
        // copy一份
        let data = JSON.parse(JSON.stringify(this.formValidate))
        // 重新排序specsCheck

        const selectSpecsList = JSON.parse(JSON.stringify(this.selectSpecsList))
        const specsCheck = this.specsCheck.map((item, index) => {
          let lastArr = []
          item.forEach((id) => {
            lastArr.push(selectSpecsList[index].productSalesAttributeValues.find((attrItem) => attrItem.id === id))
          })
          lastArr.sort((a, b) => {
            return a.displayOrder - b.displayOrder
          })
          return lastArr.map((item) => item.id)
        })
        // sku重排了
        // data.productSKUs = this.checkGroupChange(specsCheck, true)
        // 这函数内部又把data.productSKUs给改了
        this.getSkuDict(data.productSKUs)
        data.productSKUs = data.productSKUs.filter((x) => x.code)
        data.productSalesAttributeMappings = this.getSalesAttr(specsCheck)
        data.productAttributeMappings = productAttributeMappings
        data.productCategoryMappings = [data.productCategoryMappings]
        data.productColorImages = [].concat(...this.productColorImages.map((x) => x.data))
        console.log('最终数据', data);
        GoodsApi.edit(this.editId, data).then((res) => {
          this.$Message.success(this.editId ? '修改成功' : '添加成功')
          this.$router.push({ name: 'GoodsList', replace: true })
        })
      } else {
        document.querySelector('.single-page-con').scrollTop = 0
      }
    })
  }

  getSalesAttr(specsCheck?: any[]) {
    let arr: any = []
    specsCheck = specsCheck || this.specsCheck
    specsCheck.forEach((item, index) => {
      const temp = this.selectSpecsList[index]
      item.forEach((item2) => {
        arr.push({
          productSalesAttributeId: temp.id,
          productSalesAttributeValueId: item2,
        })
      })
    })
    return arr
  }

  /**
   * 批量填充sku价格和库存
   */
  handleTableDataByKey(marketPrice, price, stock) {
    let tempTableData: any = {}
    tempTableData = JSON.parse(JSON.stringify(this.tableData))
    let tempArr = this.formValidate.productSKUs.map((item, index) => {
      tempTableData[item.attributeVal]['marketPrice'] =
        marketPrice != null && marketPrice != '' ? marketPrice : tempTableData[item.attributeVal]['marketPrice']
      tempTableData[item.attributeVal]['price'] =
        price != null && price != '' ? price : tempTableData[item.attributeVal]['price']
      tempTableData[item.attributeVal]['stockQuantity'] =
        stock != null && stock != '' ? stock : tempTableData[item.attributeVal]['stockQuantity']
      item['marketPrice'] = marketPrice != null && marketPrice != '' ? marketPrice : item['marketPrice']
      item['price'] = price != null && price != '' ? price : item['price']
      item['stockQuantity'] = stock != null && stock != '' ? stock : item['stockQuantity']
      return item
    })
    this.$set(this.formValidate, 'productSKUs', tempArr)
    this.tableData = tempTableData
    //$set()方法重新渲染
    this.$set(
      this.formValidate,
      'stockQuantity',
      stock != null && stock != '' ? stock * this.formValidate.productSKUs.length : this.formValidate.stockQuantity
    )
    // this.formValidate.stockQuantity =
    //   stock != null && stock != ""
    //     ? stock * this.formValidate.productSKUs.length
    //     : this.formValidate.stockQuantity;
    this.priceSkuChange()
  }

  handleAllPriceAndStock() {
    if (!this.formValidate.productSKUs.length) {
      this.$Notice.warning({
        title: '请先选择商品规格',
      })
      return
    }
    this.batchMarketPrice = ''
    this.batchPrice = ''
    this.batchStock = ''
    // this.batchCode = ''
    this.$Modal.confirm({
      render: (h) => {
        return [
          h('Input', {
            props: {
              value: this.batchMarketPrice,
              autofocus: true,
              number: true,
              type: 'number',
              placeholder: '请填写吊牌价格',
            },
            style: {
              'margin-bottom': '10px',
            },
            on: {
              input: (val) => {
                this.batchMarketPrice = val
              },
            },
          }),
          h('Input', {
            props: {
              value: this.batchPrice,
              autofocus: true,
              number: true,
              type: 'number',
              placeholder: '请填写销售价格',
            },
            style: {
              'margin-bottom': '10px',
            },
            on: {
              input: (val) => {
                this.batchPrice = val
              },
            },
          }),
          h('Input', {
            props: {
              value: this.batchStock,
              type: 'number',
              number: true,
              placeholder: '请填写库存',
            },
            // style: {
            //   'margin-bottom': '10px'
            // },
            on: {
              input: (val) => {
                this.batchStock = val
              },
            },
          }),
          // h('Input', {
          //   props: {
          //     value: this.batchCode,
          //     placeholder: '请填写编码'
          //   },
          //   on: {
          //     input: val => {
          //       this.batchCode = val
          //     }
          //   }
          // })
        ]
      },
      onOk: () => {
        this.handleTableDataByKey(this.batchMarketPrice, this.batchPrice, this.batchStock)
      },
    })
  }

  categoryCheckGroupChange() {
    this.setAttrTableData()
  }

  setAttrTableData(productAttributeMappings?: any[]) {
    // console.log('哈哈哈', this.categorysCheck, productAttributeMappings)
    let tempData: any[] = []
    this.categorysCheck.forEach((arr, index) => {
      if (Array.isArray(arr) && arr.length) {
        let temp = JSON.parse(JSON.stringify(this.attrCategoryList[index]))
        temp.productAttributes = arr.map((item) => {
          let findItem = temp.productAttributes.find((attrItem) => attrItem['id'] === item)
          if (Array.isArray(productAttributeMappings)) {
            let find = productAttributeMappings.find((attrItem) => attrItem.productAttributeId === item)
            findItem.selectValue = find.productAttributeValueId
            findItem.customText = find.customText
          }
          return findItem
        })
        tempData.push(temp)
      }
    })
    function compare(property) {
      return function(a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    }
    // 按displayOrder字段重新排序，不然跟小程序那边顺序不一致
    tempData.forEach((item) => {
      item.productAttributes = item.productAttributes.sort(compare('displayOrder'))
    })
    this.attrTableData = tempData
    this.copyAttrTableData = this._integratedData(tempData)
    this.attrDictData = this.getAttrDictData(tempData)
  }

  // 表格合并
  handleSpan({ row, column, rowIndex, columnIndex }) {
    // console.log(row, column, rowIndex, columnIndex);
    if (columnIndex === 0) {
      return {
        rowspan: row.mergeCol === 0 ? 0 : row.mergeCol,
        colspan: row.mergeCol === 0 ? 0 : 1,
      }
    }
  }
  // 处理数据
  _integratedData(data) {
    var lastArr = []
    data.forEach((item, firstIndex) => {
      item.productAttributes.forEach((innerItem, attrIndex) => {
        innerItem.attrName = innerItem.name
        lastArr.push(
          Object.assign({}, innerItem, {
            mergeCol: attrIndex === 0 ? item.productAttributes.length : 0,
            name: item.name,
            firstIndex: firstIndex,
            attrIndex: attrIndex,
            displayOrder: item.displayOrder,
          })
        )
      })
    })
    return lastArr
  }

  getAttrDictData(attrTableData) {
    let tempTableData: any = {}
    // 拷贝一份
    tempTableData = JSON.parse(JSON.stringify(this.attrDictData))
    attrTableData.forEach((item, index) => {
      item.productAttributes.forEach((attrItem, attrIndex) => {
        if (!tempTableData[attrItem['id']]) {
          tempTableData[attrItem.id] = attrItem
        } else {
          item.productAttributes[attrIndex] = tempTableData[attrItem['id']]
        }
      })
    })
    return tempTableData
  }

  getCategorysCheck(productAttributeMappings) {
    let tempCheck: any = []
    productAttributeMappings.forEach((item) => {
      // forEach中断循环
      try {
        this.attrCategoryList.forEach((categoryItem, index) => {
          let findItem = categoryItem.productAttributes.find(
            (attrItem) => attrItem['id'] === item['productAttributeId']
          )
          if (!Array.isArray(tempCheck[index])) {
            tempCheck[index] = []
          }
          if (findItem) {
            tempCheck[index].push(item.productAttributeId)
            throw { message: 'Found, exit loop' }
          }
        })
      } catch (e) {}
    })
    return tempCheck
  }

  onCategoryChange(e: { id: string; name: string }) {
    // this.formValidate.productCategoryMappings = e.id
    // console.log(this.$refs.formValidate)
  }
}
